import ActivitiesShell from "../components/activities/ActivitiesShell";

export default function ActivitiesGallery() {
  return (
    <ActivitiesShell
      introTitle="A gallery of our shared moments."
      introSubtitle="A simple photo wall for events, celebrations, seva visits, and community gatherings."
    >
      <div className="card-premium">
        <div className="overline mb-4">Gallery</div>
        <div className="rounded-2xl border border-dashed border-black/10 bg-cream-deep/60 p-5 text-sm text-ink-muted">
          No gallery images have been posted yet.
        </div>
      </div>
    </ActivitiesShell>
  );
}
